// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["id"]

  jump() {
    event.preventDefault()
    const id = this.data.get("id")

    // DEBUG
    // console.log("jumping")
    // console.log(document.getElementById(id))

    const element = document.getElementById(id)
    let top = element.offsetTop;
    if(id == "singleLeadFormMobileOnly" || id == "singleLeadForm") {
      top = element.offsetTop - 270;
      if(window.innerWidth < 720) {
        top = element.offsetTop - 100;
      }
    }
    window.scrollTo(0, top)
    animateCSS(element, 'headShake')
  }
}

const animateCSS = (node, animation, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;

    console.log(node)
    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd() {
      node.classList.remove(`${prefix}animated`, animationName);
      node.removeEventListener('animationend', handleAnimationEnd);

      resolve('Animation ended');
    }

    node.addEventListener('animationend', handleAnimationEnd);
  });

